import { Text, StyleSheet, View, ViewStyle, StyleProp, TextStyle, Pressable } from "react-native";
import { forwardRef, useImperativeHandle, useState } from "react";
import { ImageView } from "./ImageView";
import { color_999999, color_main, white } from "../assets/style/colors";
import { ButtonView } from "./ButtonView";
import CheckBox from "@react-native-community/checkbox";
import { isIos } from "../AppEvent";
import { CheckBoxView } from "./CheckBoxView";

export type CheckboxHandle = {
    changeChecked: (check: boolean) => void

    isChecked: () => boolean
}
type TextType = {
    text: string,
    isHighlight?: boolean
    style?: ViewStyle | StyleProp<TextStyle>
    onClick?: () => void
}
type CheckboxProps = {
    text?: string
    texts?: TextType[]
    style?: ViewStyle
}
export const Checkbox = forwardRef<CheckboxHandle, CheckboxProps>((props, ref) => {
    const [checked, setChecked] = useState(false);
    const { texts, text, style } = props
    useImperativeHandle(ref, () => ({
        changeChecked(check) {
            setChecked(check)
        },
        isChecked(): boolean {
            return checked
        }
    }))
    return (
        <Pressable style={[styles.checkboxBase, { paddingHorizontal: 32 }, style]} onPress={() => setChecked(!checked)}>
            <CheckBoxView
                value={checked}
                style={{ width: 15, height: 15 }}
                onValueChange={setChecked} />
            <View style={[{
                // backgroundColor:'green',
                marginLeft: isIos ? 8 : 18,
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'row',
                flexWrap: 'wrap'
            }]}>
                {texts && texts.length > 0 ? texts.map((item, index) => {
                    return (<ButtonView
                        key={index.toString()}
                        textStyle={[
                            styles.textStyle,
                            item.isHighlight && { color: color_main },
                            item.style
                        ]}
                        onPress={item.onClick}
                        text={item.text} />)
                }) :
                    <Text style={styles.textStyle}>{text}</Text>}
            </View>
        </Pressable>
    );
})
const styles = StyleSheet.create({
    checkboxBase: {
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'row',
    },
    textStyle: {
        color: color_999999, fontSize: 12
    }
})